export default {"src":"/_next/static/media/Settings.acc545ab.svg","height":16,"width":16};